const BLOCKED_CURRENCY_ROUTE_PREFIXES = [
  '/checkout',
  '/order-complete',
  '/order-failed',
  '/account',
  '/forgot-password',
  '/reset-password',
  '/confirmation',
];

export const shouldShowCurrencySelector = (pathname = '/') => {
  if (!pathname) {
    return true;
  }

  const normalizedPathname = pathname.endsWith('/') && pathname !== '/'
    ? pathname.slice(0, -1)
    : pathname;

  return !BLOCKED_CURRENCY_ROUTE_PREFIXES.some((route) => {
    if (route === '/') {
      return normalizedPathname === '/';
    }

    return normalizedPathname === route || normalizedPathname.startsWith(`${route}/`);
  });
};
